module.exports = __webpack_public_path__ + "img/GHS04.537376fd.webp";